import Layout from './Component/layout'

function App() {
  return (
    <div>
      <Layout/>
    </div>
  );
}

export default App;
